import type { User } from '@/shared/types'

const VN_FAMILY_NAMES = ['Nguyễn', 'Trần', 'Lê', 'Phạm', 'Hoàng', 'Vũ', 'Đặng', 'Bùi', 'Đỗ', 'Hồ', 'Phan', 'Đinh']
const VN_MIDDLE_NAMES = ['Văn', 'Hữu', 'Đức', 'Quang', 'Minh', 'Hoàng', 'Anh', 'Thanh', 'Xuân', 'Trung']
const VN_GIVEN_NAMES = ['Hùng', 'Dũng', 'Tuấn', 'Sơn', 'Long', 'Tùng', 'Hải', 'Nam', 'Phong', 'Bình', 'An', 'Khôi', 'Việt', 'Cường', 'Đạt']

const RANKS = ['Trung tướng', 'Thiếu tướng', 'Đại tá', 'Thượng tá', 'Trung tá', 'Thiếu tá', 'Đại uý', 'Thượng uý']
const POSITIONS_BY_LEVEL: Record<string, string[]> = {
  'quan-chung': ['Tư lệnh', 'Phó Tư lệnh', 'Tham mưu trưởng', 'Phó TMT'],
  'su-doan': ['Sư đoàn trưởng', 'Phó Sư đoàn trưởng', 'TMT Sư đoàn'],
  'trung-doan': ['Trung đoàn trưởng', 'Phó Trung đoàn trưởng', 'TMT Trung đoàn'],
  'tieu-doan': ['Tiểu đoàn trưởng', 'Phó Tiểu đoàn trưởng', 'CT Tiểu đoàn'],
  'dai-doi': ['Đại đội trưởng', 'Phó Đại đội trưởng', 'CT Đại đội'],
}

const AVATAR_COLORS = ['#1e6091', '#0e7490', '#15803d', '#a16207', '#b91c1c', '#7c3aed', '#be185d']

function pick<T>(arr: T[], idx: number): T {
  return arr[idx % arr.length]
}

function buildName(idx: number): { fullName: string } {
  const family = pick(VN_FAMILY_NAMES, idx)
  const middle = pick(VN_MIDDLE_NAMES, Math.floor(idx / 7) + idx)
  const given = pick(VN_GIVEN_NAMES, Math.floor(idx / 3) + idx * 2)
  return { fullName: `${family} ${middle} ${given}` }
}

import { UNITS } from './units'

function generateUsers(): User[] {
  const users: User[] = []
  let counter = 0

  for (const level of ['quan-chung', 'su-doan', 'trung-doan', 'tieu-doan', 'dai-doi'] as const) {
    const unitsAtLevel = UNITS.filter((u) => u.level === level)
    const positions = POSITIONS_BY_LEVEL[level]
    const sampleUnits = level === 'quan-chung' ? unitsAtLevel : unitsAtLevel.slice(0, level === 'su-doan' ? 6 : level === 'trung-doan' ? 6 : level === 'tieu-doan' ? 8 : 12)

    sampleUnits.forEach((unit) => {
      const userCount = level === 'quan-chung' ? 4 : level === 'su-doan' ? 2 : 1
      for (let i = 0; i < userCount; i++) {
        const idx = counter++
        const { fullName } = buildName(idx)
        const rank = pick(RANKS, level === 'quan-chung' ? i : i + 2)
        const position = pick(positions, i)
        users.push({
          id: `u-${idx + 1}`,
          username: `user${idx + 1}`,
          fullName,
          rank,
          position,
          unitId: unit.id,
          roleLevel: level,
          avatarColor: pick(AVATAR_COLORS, idx),
        })
      }
    })
  }

  return users
}

export const USERS: User[] = generateUsers()

export const DEMO_USER: User = USERS[0]
